/**********************************************************************************
CHID - 1      Usha       24 / 01 / 2020      1973: Related Symptoms Implementation
    ******************************************************************************** */

import Single from "./Single";
import GroupSingle from "./GroupSingle";
import GroupMultiple from "./GroupMultiple";
import LoadingScreen from "features/LoadingScreen";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLightbulb } from "@fortawesome/free-solid-svg-icons";
import i18n from "./../../../i18n";

export default ({ state, actions, history, nextStepName, setState }) => {
{state.triageRequest.activeMenu = "questions"}
 if(state.isLoading_RelativeSymptom) {setState({ isLoading_RelativeSymptom:false});}
  return (
    <div className="modal-content">
      <LoadingScreen isLoading={state.isLoading}>
        <div className="article-width">
          <div>
            {state.Questions.question.type === "single" ? (
              <Single
                {...{ state, actions, history, nextStepName, setState }}
              />
            ) : state.Questions.question.type === "group_single" ? (
              <GroupSingle
                {...{ state, actions, history, nextStepName, setState }}
              />
            ) : (
              <GroupMultiple
                {...{ state, actions, history, nextStepName, setState }}
              />
            )}
          </div>
        </div>
        <div className="hintstyles">
          <div className="iconstyle " style={{ position: "absolute" }}>
            <FontAwesomeIcon icon={faLightbulb} />
          </div>
          <div style={{ float: "right", color: "black" }}>
            {state.triageRequest.hint1}{" "}
            <strong>{state.triageRequest.hintsymptom}</strong>{" "}
            {i18n.language=== "de" ? state.triageRequest.hint3 : ""}
            {state.triageRequest.hint2}{" "}
          </div>
        </div>
      </LoadingScreen>
    </div>
  );
};
